/**
 * This module is designed to be loaded as the very first import in the app.
 * This is important to make sure that the logging and error reporting is
 * setup and initialised before any other modules are imported and start trying
 * to log things. If we don't do this first those log calls end up being lost
 * because the logger may not have been enabled at the point the call is made.
 */
import { isDebugEnabled, logger, reportErrorDetails } from '$utils'

if (isDebugEnabled()) {
  logger.enable()
  logger.info('Loaded app logging enabled')
}

logger.info('Registering error event listeners')

window.addEventListener('error', (event) => {
  const error = event.error || new Error(event.message || 'Unknown error')
  logger.error('Unhandled global error in React app context: %o', error)
  reportErrorDetails(error)
})

window.addEventListener('unhandledrejection', (event) => {
  logger.error(
    'Unhandled promise rejection in React app context: %o',
    event.reason
  )
  reportErrorDetails(event.reason)
})
